module.exports = __webpack_public_path__ + "2d3966a785b4b4c33465077e0edc23cf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/quiz-icons/warmup-complete.png
// module id = 2925
// module chunks = 0